import { Controller } from 'stimulus'
import { jsRequest, csrfToken } from '@react/helpers/fetch'

export default class extends Controller {

  reload(event) {
    const url = new URL(this.data.get("path"), location.origin)
    if (event.target.value) url.searchParams.set('client', event.target.value)
    jsRequest(url)
  }

  submit(event) {
    event.preventDefault()
    const form   = this.element
    const submit = form.querySelector('[type=submit]')
    if (submit) submit.disabled = true

    fetch(form.action, {
      method:      'POST',
      body:        new FormData(form),
      credentials: 'same-origin',
      headers:     { 'X-CSRF-Token': csrfToken(), 'X-Requested-With': 'XMLHttpRequest' }
    })
    .then(response => {
      if (!response.ok) throw new Error(`${response.status} ${form.action}`)
      return response.text()
    })
    .then(text => eval(text))
    .catch(() => {
      if (submit) submit.disabled = false
      flashAlert(I18n.t('errors.messages.oops'))
    })
  }

  toggleTarget(event) {
    const target = document.getElementById(event.target.dataset.targetId)
    if (!target) return

    const moving = event.target.value === 'move'
    target.classList.toggle('d-none', !moving)
    target.querySelector('select').required = moving
  }
}
